module.exports = function atoa (a, n) { return Array.prototype.slice.call(a, n); }



//////////////////
// WEBPACK FOOTER
// ./~/atoa/atoa.js
// module id = 988
// module chunks = 7